/**
 * Replaces `%{token}` placeholders in `value` with the matching entry of `replacements`.
 * Tokens without a matching replacement are left as-is.
 */
export function interpolate(value: string, replacements: Readonly<Record<string, string>>): string {
	return value.replace(/%\{(\w+)\}/g, (match, token: string) => replacements[token] ?? match);
}
